/**
 * GroupEmojiPicker — iter245. Curated emoji grid for group icons.
 * Controlled: value (emoji string or ''), onChange(emoji|'').
 */
const EMOJIS = [
  '🥒', '🎾', '🏸', '🏏', '⚽', '🏐', '🏓', '🏀',
  '🏊', '🏋️', '🧗', '🚴', '🏔️', '🏖️', '✈️', '🚗',
  '⛺', '🎉', '🎂', '💍', '🏠', '🍕', '🍻', '☕',
  '💼', '🎬', '🎮', '🎵', '📚', '🐾', '🌴', '🔥',
];

export default function GroupEmojiPicker({ value, onChange }) {
  return (
    <div data-testid="group-emoji-picker">
      <div className="grid grid-cols-8 gap-1">
        {EMOJIS.map((e) => (
          <button
            key={e}
            type="button"
            onClick={() => onChange(value === e ? '' : e)}
            data-testid={`emoji-option-${e}`}
            aria-label={`Pick ${e}`}
            className={`h-9 rounded-lg text-lg leading-none flex items-center justify-center transition-colors ${
              value === e ? 'bg-primary/20 ring-2 ring-primary' : 'hover:bg-muted'
            }`}
          >
            {e}
          </button>
        ))}
      </div>
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          data-testid="emoji-clear-btn"
          className="mt-1.5 text-xs font-semibold text-muted-foreground hover:text-foreground transition-colors"
        >
          Clear emoji ({value})
        </button>
      )}
    </div>
  );
}
